import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { VehicleSummaryStyled } from '../VehicleSummaryStyled';
import { rem } from 'polished';

export const VehicleSummaryStyledAP = styled(VehicleSummaryStyled)`
    .benefits-wrapper {
        .benefits {
            background: ${({ theme }) => theme.colors.white};
        }
    }
    .summary-price-container {
        .body > .body-wrapper {
            .or,
            .price {
                line-height: ${rem('20px')};
            }

            .totalMonthlyPriceWrapper {
                align-items: baseline;
            }
        }
    }

    span.title {
        font-size: ${rem('14px')};
        padding: ${rem('31px')} 0 ${rem('31px')} 0;

        @media (max-width: ${breakpoints.sm}px) {
            display: none;
        }
    }
`;
